import { Component, Input, OnInit } from "@angular/core";
import { ICourse } from "src/app/services";

@Component({
  selector: "app-course-info",
  templateUrl: "./course-info.component.html",
  styleUrls: ["./course-info.component.scss"],
})
export class CourseInfoComponent implements OnInit {
  @Input()
  public course: ICourse;

  constructor() {

  }

  ngOnInit() {

  }

}
